import { useDispatch } from 'react-redux';
import { editUnitFlow } from 'store/units/sagaActions';
import type { FlowInterface } from 'store/units/types';

export const useEditInputFlow = (unitId: string, inputFlow: FlowInterface) => {
  const dispatch = useDispatch();

  const setValue = <U extends keyof FlowInterface>(
    key: U,
    val: FlowInterface[U],
  ) => {
    dispatch(editUnitFlow(unitId, { ...inputFlow, [key]: val }));
  };

  const setValues = (values: Partial<FlowInterface>) => {
    dispatch(editUnitFlow(unitId, { ...inputFlow, ...values }));
  };

  return { setValue, setValues };
};
